// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMRadioGroup.tsx — PropelMapper radio-card group.
// Selectable bordered cards (label + optional description); selected card gets a
// Pine border + faint Pine fill and a filled dot. Real hidden radios for a11y.
// Horizontal by default; `vertical` stacks them. --pm-focus-ring on focus.

const PMRADIO_CSS = `
.pmradio-group{display:flex;gap:12px;flex-wrap:wrap}
.pmradio-group--vertical{flex-direction:column;flex-wrap:nowrap}
.pmradio-group--disabled{opacity:.5;pointer-events:none}
.pmradio{box-sizing:border-box;flex:1;min-width:200px;display:flex;align-items:flex-start;gap:12px;border:1.5px solid var(--pm-border);border-radius:var(--pm-radius-l,12px);padding:14px 16px;cursor:pointer;transition:.13s;background:var(--pm-surface);font-family:var(--pm-font-sans)}
.pmradio:hover{border-color:var(--pm-primary-light)}
.pmradio.is-on{border-color:var(--pm-primary);background:color-mix(in srgb,var(--pm-primary) 6%,transparent)}
.pmradio input{position:absolute;opacity:0;width:1px;height:1px;margin:0}
.pmradio-dot{width:20px;height:20px;border-radius:50%;border:2px solid var(--pm-border-dark);flex:0 0 20px;display:grid;place-items:center;transition:.13s;margin-top:1px}
.pmradio.is-on .pmradio-dot{border-color:var(--pm-primary)}
.pmradio.is-on .pmradio-dot::after{content:"";width:10px;height:10px;border-radius:50%;background:var(--pm-primary)}
.pmradio input:focus-visible + .pmradio-dot{box-shadow:var(--pm-focus-ring)}
.pmradio-tx strong{display:block;font:var(--pm-title-m);font-weight:700;color:var(--pm-fg-1)}
.pmradio-tx span{font:var(--pm-body-s);color:var(--pm-fg-2)}
`;
function pmradioEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmradio-css")) return;
  const s = document.createElement("style"); s.id = "pmradio-css"; s.textContent = PMRADIO_CSS;
  document.head.appendChild(s);
}
export function PMRadioGroup({ options = [], value, onChange, vertical = false, name, disabled = false, className = "", style = {}, ...rest }) {
  pmradioEnsureCSS();
  const gname = name || ("pmradio-" + Math.random().toString(36).slice(2, 8));
  return (
    <div className={"pmradio-group" + (vertical ? " pmradio-group--vertical" : "") + (disabled ? " pmradio-group--disabled" : "") + (className ? " " + className : "")} role="radiogroup" style={style} {...rest}>
      {options.map((o) => {
        const opt = typeof o === "string" ? { value: o, label: o } : o;
        const on = opt.value === value;
        return (
          <label key={opt.value} className={"pmradio" + (on ? " is-on" : "")}>
            <input type="radio" name={gname} value={opt.value} checked={on} disabled={disabled}
              onChange={() => onChange && onChange(opt.value)} />
            <span className="pmradio-dot" />
            <span className="pmradio-tx">
              <strong>{opt.label}</strong>
              {opt.desc ? <span>{opt.desc}</span> : null}
            </span>
          </label>
        );
      })}
    </div>
  );
}
